import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import QRDessCode from "./Pages/QRDessCode";
import Technologies from "./Pages/Technologies";
import MatrixBackground from "./MatrixBackground";
function App() {
  return (
    <>
      <MatrixBackground />
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route  path="/projects/QRDessCode" element={<QRDessCode />} />
          <Route path="/technologies" element={<Technologies />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}
export default App;
